<template>
  <component :is="layout">
    <!-- <transition
        appear
        v-bind:css="false"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:leave="leave"
      > -->
    <router-view />
    <!-- </transition> -->
  </component>
</template>

<script>
import { mapGetters } from "vuex";
// import gsap from "gsap";
// import { TweenMax } from "gsap/all";

const default_layout = "default-layout";
export default {
  name: "Apps",
  computed: {
    layout() {
      return this.$route.meta.layout || default_layout;
    },
    ...mapGetters({
      background: "getBackground",
    }),
  },
  // data() {
  //   return {
  //     cacheDB: null,
  //     cacheValue: [],
  //     isBrowserSupportLocalDB: true,
  //   };
  // },
  mounted() {
    this.$store.dispatch("getBackground", { etag: null });
    // IndexedDB [HOLD]
    // this.cacheDB = await this.getCacheDB();
    // this.cacheValue = await this.readCache();
    // if (this.cacheValue.length == 0) {
    //   this.$store
    //     .dispatch("getBackground", { etag: null })
    //     .then(async (result) => {
    //       await this.addCache(this.background);
    //     });
    // } else {
    //   this.$store
    //     .dispatch("getBackground", { etag: this.cacheValue[0].etag })
    //     .then((result) => {
    //       if (this.background == "not modified") {
    //         this.$store.commit("getBackground", this.cacheValue[0]);
    //       } else {
    //         this.removeCache(this.cacheValue[0]);
    //         this.addCache(this.background);
    //       }
    //     });
    // }
  },
  methods: {
    // beforeEnter(el) {
    //   gsap.TweenMax.set(el, { opacity: 0 });
    // },
    // enter(el, done) {
    //   gsap.TweenMax.to(el, 1, { opacity: 1, onComplete: done, ease: "elastic" });
    // },
    // leave(el, done) {
    //   gsap.TweenMax.to(el, 1, { opacity: 0, onComplete: done });
    // },
    // IndexedDB [HOLD]
    // async getCacheDB() {
    //   return new Promise((resolve, reject) => {
    //     if (this.cacheDB) {
    //       return resolve(this.cacheDB);
    //     }
    //     let request = window.indexedDB.open(
    //       process.env.VUE_APP_LOCAL_DB,
    //       process.env.VUE_APP_LOCAL_DB_VERSION
    //     );
    //     request.onerror = (e) => {
    //       console.log("Error opening cache db", e);
    //       reject("Error");
    //     };
    //     request.onsuccess = (e) => {
    //       resolve(e.target.result);
    //     };
    //     request.onupgradeneeded = (e) => {
    //       let cacheDB = e.target.result;
    //       let objectStore = cacheDB.createObjectStore("assets", {
    //         autoIncrement: true,
    //         keyPath: "id",
    //       });
    //     };
    //   });
    // },
    // async readCache() {
    //   return new Promise((resolve, reject) => {
    //     let trans = this.cacheDB.transaction(["assets"], "readonly");
    //     trans.oncomplete = (e) => {
    //       resolve(cache);
    //     };
    //     let store = trans.objectStore("assets");
    //     let cache = [];
    //     store.openCursor().onsuccess = (e) => {
    //       let cursor = e.target.result;
    //       if (cursor) {
    //         cache.push(cursor.value);
    //         cursor.continue();
    //       }
    //     };
    //   });
    // },
    // Insert Data to LocalDB
    // async addCache(data) {
    //   return new Promise((resolve, reject) => {
    //     let trans = this.cacheDB.transaction(["assets"], "readwrite");
    //     trans.oncomplete = (e) => {
    //       resolve();
    //     };
    //     let store = trans.objectStore("assets");
    //     store.add(data);
    //     this.readCache().then((result) => {
    //       this.cacheValue = result;
    //     });
    //   });
    // },
    // async removeCache(background) {
    //   let db = await this.getCacheDB();
    //   return new Promise((resolve, reject) => {
    //     let trans = db.transaction(["assets"], "readwrite");
    //     trans.oncomplete = () => {
    //       resolve();
    //     };
    //     let store = trans.objectStore("assets");
    //     store.delete(background.id);
    //   });
    // },
  },
};
</script>
